import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './core/reportWebVitals';

// Canlı ortamda console.log'ları kapatır
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {}; // İsteğe bağlı
  console.warn = () => {};  // İsteğe bağlı
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
